export default "__VITE_ASSET__Cnj0qFcp__"